<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-position="top" label-width="200px" class="fb-form">

            <el-form-item label="Hotel Name" prop="hotelName" :error="formErrorMsg.hotelName">
                <el-input v-model="formData.hotelName" placeholder="Please input hotel name"></el-input>
            </el-form-item>


            <el-form-item label="Tips Template" prop="Tips Template">
                <el-input v-model="formData.tipsTpl" placeholder="Please input tips template"></el-input>
            </el-form-item>


            <el-form-item label="App Bg" prop="appBg">
                <input type="file" ref="appLogoFile"  @change="handlePhotoChange" style="display: none">

                <div v-if="logoUrl" style="text-align: center;display: inline-block">
                    <img  @click="$refs.appLogoFile.click()"  :src="logoUrl" @error="logoUrl=''" alt="" style="max-width: 200px;cursor: pointer;border: 1px solid #f0f0f0;"><br>
                </div>
                <div @click="$refs.appLogoFile.click()" v-else style="display: inline-block;width: 200px;line-height: 100px;border: 1px solid #f0f0f0;text-align: center;cursor: pointer">
                    Please choose bg picture
                </div>
                <div>
                    <el-button size="mini" @click="formData.appBgUrl=''">Clear</el-button>
                </div>
            </el-form-item>

          <el-form-item label="Title Color" prop="Title Color">
            <el-color-picker v-model="formData.titleColor"></el-color-picker>
          </el-form-item>

          <el-form-item label="Time Color" prop="Time Color">
            <el-color-picker v-model="formData.timeColor"></el-color-picker>
          </el-form-item>

          <el-form-item label="Date Color" prop="Date Color">
            <el-color-picker v-model="formData.dateColor"></el-color-picker>
          </el-form-item>


          <el-form-item label="Tips Color" prop="Tips Color">
            <el-color-picker v-model="formData.tipsColor"></el-color-picker>
          </el-form-item>

          <el-form-item label="Hotel Name Color" prop="Hotel Name Color">
            <el-color-picker v-model="formData.hotelNameColor"></el-color-picker>
          </el-form-item>

          <el-form-item label="Press Color" prop="Press Color">
            <el-color-picker v-model="formData.pressColor"></el-color-picker>
          </el-form-item>


         <el-form-item label="Sn Color" prop="Sn Color">
            <el-color-picker v-model="formData.snColor"></el-color-picker>
          </el-form-item>

          <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">Confirm</el-button>
                <el-button @click="handleReset('form')">Reset</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>
    export default {
        name: "SysConfig",
        components: {},
        data() {
            return {
                api:{
                   sysConfig:this.$api.appCommon.sysConfig,
                },
                formErrorMsg:{},
                formData: {
                    code:'',
                    hotelName: '',
                    tipsTpl: '',
                  appBgUrl:'',
                  titleColor: '',
                  timeColor: '',
                  dateColor: '',
                  tipsColor: '',
                  hotelNameColor: '',
                  pressColor: '',
                  snColor: ''
                },
                rules: {

                },
                logoUrl:""
            }
        },
        watch:{
            'formData.appBgUrl':{
                deep:true,
                handler:function () {
                    if(this.formData.appBgUrl) this.logoUrl = (this.$api.commonFile.download + '?code=' + this.formData.appBgUrl)
                    else this.logoUrl = ''
                }
            },
        },
        methods: {
            async handlePhotoChange(){
                let formData = new FormData();
                formData.append("file",this.$refs['appLogoFile'].files[0]);
                formData.append("category","ART_PIC")
                let resp = await this.$http.post(this.$api.appCommon.uploadFile,formData);
                console.log(resp);
                debugger
                if(resp.data.status === 200){
                    this.formData.appBgUrl = resp.data.data.code;
                }
            },
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {
                        vm.$http.post(vm.$api.appCommon.updateSysConfig,this.$qs.stringify(this.formData)).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            }else if(resp.data.status === 400){
                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(() => {
                                        vm.formErrorMsg[a.name] = a.message;
                                    });


                                });
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                });
                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },

        created() {

            let vm = this;
            this.$http.post(this.api.sysConfig).then(function (resp) {
                for(let key in resp.data.data){
                    for(let fKey in vm.formData){
                        vm.formData[fKey] = resp.data.data[key][fKey]



                    }
                }
            });

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form {
        max-width: 500px;
    }

</style>
